import styled from "styled-components";
export const OrderList = styled("ul")({
    listStyle: "none",
    margin: 0,
    padding: 0,
    width: "100%",
    "> li": {
        marginBottom: 8,
    },
});
